<tr (click)="eventService.displaySaleActions(event) || eventService.displayRefundActions(event) ? openPurchaseView.emit(event) : null">
  <td class="image" *ngIf="hasImage">
    <div class="image-wrapper" [ngStyle]="{'background-image': image}">
      <app-s3-downloader *ngIf="event.boEvent && event.image" [model]="event.image" [ownerId]="event.eventId"
                         [type]="S3UploaderTypes.Event" [ratio]="S3UploaderRatios.Square"
                         [ownerCentreId]="event.externalOwnerCentreId" [noBorder]="true"></app-s3-downloader>
    </div>
  </td>
  <td class="heading-5">
    <mat-icon class="svg-icon text-secondary right-spacer" [svgIcon]="'salespoints'" *ngIf="event.boEvent"></mat-icon>
    {{event.title}}
  </td>
  <td class="align-right venue-cell">
    <span *ngIf="event.venueTitle?.length">{{event.venueTitle}}<ng-container *ngIf="event.onlineLocation?.length">,&nbsp;</ng-container></span>
    <span *ngIf="event.onlineLocation?.length" class="two-line-overflow">{{event.onlineLocation}}</span>
  </td>
  <td class="date">
    <div class="flex space-between">
      <div class="flex decreased-margin" *ngIf="event.event">
        <ng-container *ngIf="!isPeriodSameDay">
          <span>{{ event.event.start | moment: { tz: event.timezone } }}</span>
          <span>{{ event.event.start | moment: { format: viewService.conf.timeFormat, tz: event.timezone } }}</span>
          <ng-container *ngIf="event.event?.end">
            <span>-</span>
            <span>{{ event.event.end | moment: { tz: event.timezone } }}</span>
            <span>{{ event.event.end | moment: { format: viewService.conf.timeFormat, tz: event.timezone } }}</span>
          </ng-container>
        </ng-container>
        <div class="flex decreased-margin" *ngIf="isPeriodSameDay">
          <span>{{ event.event.start | moment: { tz: event.timezone } }}</span>
          <span>{{ event.event.start | moment: { format: viewService.conf.timeFormat, tz: event.timezone } }} -
            {{ event.event.end | moment: { format: viewService.conf.timeFormat, tz: event.timezone } }}</span>
        </div>
      </div>

      <span class="text-warning left-spacer" *ngIf="hasSubStatus">
        <ng-container *ngIf="isPresaleEnded || isPresaleEndedState">{{'general.api_sales_pre_sale_ended' | translate}}</ng-container>
        <ng-container *ngIf="isSoldOut || isSoldOutState">{{'general.api_sales_sold_out' | translate}}</ng-container>
        <ng-container *ngIf="isSaleStartsOn">
          {{'general.api_sales_sale_start_on' | translate}} {{ event.sale.start | moment: { withTime: true } }}
        </ng-container>
        <ng-container *ngIf="isSuspended">{{'general.api_sales_suspended' | translate}}</ng-container>
        <ng-container *ngIf="isRefundable && !event.substatusId">{{'general.api_sales_refund' | translate}}</ng-container>
        <ng-container *ngIf="isTicketsCurrentlyUnavailableState">{{'general.api_sales_tickets_currently_unavailable' | translate}}</ng-container>
        <ng-container *ngIf="isPostponed">{{'general.api_sales_postponed' | translate}}</ng-container>
      </span>
    </div>
  </td>
  <td class="align-right min-width actions">
    <button mat-button class="icon-button left-spacer input-button" *ngIf="eventService.displaySaleActions(event)"
            (click)="$event.stopPropagation(); openPurchaseView.emit(event)" [disabled]="eventService.isPurchaseViewDisabled(event, cartService.cartDraftEvent)">
      <mat-icon class="svg-icon" [svgIcon]="'cart'"></mat-icon>
    </button>
    <button mat-button class="icon-button left-spacer input-button" *ngIf="eventService.displayRefundActions(event)"
            (click)="$event.stopPropagation(); openPurchaseView.emit(event)" [disabled]="eventService.isPurchaseViewDisabled(event, cartService.cartDraftEvent)">
      <mat-icon class="svg-icon" [svgIcon]="'cart'"></mat-icon>
    </button>
    <button mat-button class="icon-button left-spacer input-button" (click)="$event.stopPropagation(); openEventDetails.emit(event)">
      <mat-icon class="svg-icon" [svgIcon]="'info'"></mat-icon>
    </button>
    <button mat-button class="icon-button left-spacer input-button" *ngIf="!event.boEvent && authService.hasBookingViewPrivilege"
            (click)="$event.stopPropagation(); openEventBookings.emit(event)">
      <mat-icon class="svg-icon" [svgIcon]="'bookings'"></mat-icon>
    </button>
  </td>
</tr>
